import { SettingsMenuButton } from "@/components/nav/SettingsMenuButton";
import { SettingsSideNav } from "@/components/nav/SettingsSideNav";
import { SIDE_NAV_WIDTH } from "@/css/constants";

interface SettingsLayoutProps {
  pageLoading?: boolean;
  children?: React.ReactNode;
}

export function SettingsLayout({
  pageLoading = true,
  children,
}: SettingsLayoutProps) {
  return (
    <>
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <SettingsSideNav width={SIDE_NAV_WIDTH} pageLoading={pageLoading} />
      </div>

      {/* Mobile header */}
      <div className="block md:hidden">
        <div className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-border px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <SettingsMenuButton pageLoading={pageLoading} />
            </div>
          </div>
        </div>
      </div>

      {/* Content wrapper with appropriate padding */}
      {children && (
        <div className="pt-16 md:pt-0 md:ml-sidebar">{children}</div>
      )}
    </>
  );
}
